var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils.js";
import { Search } from "lucide-react";
var Input = React.forwardRef(function (_a, ref) {
    var className = _a.className, type = _a.type, searchBar = _a.searchBar, icon = _a.icon, props = __rest(_a, ["className", "type", "searchBar", "icon"]);
    if (searchBar || icon) {
        return (_jsxs("div", { className: "relative w-full", children: [_jsx("span", { className: "absolute top-1/2 left-3 -translate-y-1/2", children: icon || (searchBar && _jsx(Search, { className: "h-4 w-4 text-muted-foreground" })) }), _jsx("input", __assign({ type: type, className: cn("flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-input-color dark:placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", (searchBar || icon) && "pl-10", className), ref: ref }, props))] }));
    }
    return (_jsx("input", __assign({ type: type, className: cn("flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-input-color dark:placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className), ref: ref }, props)));
});
Input.displayName = "Input";
export { Input };
